// Preserve friendly wording for legacy values while allowing every subject to
// supply its own curriculum classification without a frontend release.

export const STUDY_AREA_LABELS = {
  beginning_knowledge_personal_social_wellbeing:
    "Personal and Social Well-being",
  creative_arts: "Creative Arts",
  physical_education: "Physical Education",
};

export const studyAreaLabel = (value) => {
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;
  if (STUDY_AREA_LABELS[trimmed]) return STUDY_AREA_LABELS[trimmed];

  const readable = trimmed.replace(/[_-]+/g, " ").replace(/\s+/g, " ");
  return readable.charAt(0).toUpperCase() + readable.slice(1);
};

export const BLOCK_TYPE_LABELS = {
  introduction: "Introduction",
  teacher_input: "Teach",
  learner_activity: "Class activity",
  assessment: "Observe",
  reflection: "Reflect",
  warm_up: "Warm-up",
  main_activity: "Main activity",
  cool_down: "Cool-down",
};
